import axios from "axios";
import backend_url from "../routes/API_URL";

const API_URL = backend_url['api_url'];

class AuthService {
  constructor() {
    const user = sessionStorage.getItem('uid');
    if (user != null) {
      sessionStorage.setItem("uid", user);
    } else {
      sessionStorage.removeItem("uid");
    }
  }
  
  login(email, password) {
    return axios.post(API_URL + "/users/login", {
      'user_email': email, 
      'user_password': password
    })
    .then((response) => {
      console.log('login response from authService.js : ', response.data);
      
      if (response.data.token) {
        // Store all user data from response
        sessionStorage.setItem("uid", response.data.data.user_id);
        sessionStorage.setItem("fname", response.data.data.first_name || '');
        sessionStorage.setItem("mname", response.data.data.middle_name || '');
        sessionStorage.setItem("lname", response.data.data.last_name || '');
        sessionStorage.setItem("uname", response.data.data.user_name || '');
        sessionStorage.setItem("urole", response.data.data.user_role || '');
        sessionStorage.setItem("uphone", response.data.data.user_phone || '');
        sessionStorage.setItem("umail", response.data.data.user_email || '');
        sessionStorage.setItem("sector", response.data.data.sector_id || '');
        
        // IMPORTANT: Store school_id instead of emis_id
        sessionStorage.setItem("school_id", response.data.data.school_id || '');
        
        sessionStorage.setItem("zone", response.data.data.zone_id || '');
        sessionStorage.setItem("district", response.data.data.district_id || '');
        sessionStorage.setItem("division", response.data.data.division_id || '');
        sessionStorage.setItem("override_sector", response.data.data.override_sector || false);
        sessionStorage.setItem("token", response.data.token);
        
        return response.data;
      }
    }).catch(error => {
      console.error('Login error:', error);
      return error;
    });
  }

  logout() {
    sessionStorage.clear();
  }
  
  setLoggeedInUser = user => {
    sessionStorage.setItem("uid", JSON.stringify(user));
  };
  
  /**
   * Returns the authenticated user
   */
  getAuthenticatedUser = () => {
    if (!sessionStorage.getItem("uid")) return null;
    return sessionStorage.getItem("uid");
  };
}

export default new AuthService();